export const AUTOCOMPLETE_FETCH_FAILURE =
  'filtering/AUTOCOMPLETE_FETCH_FAILURE';
export const AUTOCOMPLETE_FETCH_SUCCESS =
  'filtering/AUTOCOMPLETE_FETCH_SUCCESS';
export const AUTOCOMPLETE_LABELS_FETCH_FAILURE =
  'filtering/AUTOCOMPLETE_LABELS_FETCH_FAILURE';
export const AUTOCOMPLETE_LABELS_FETCH_SUCCESS =
  'filtering/AUTOCOMPLETE_LABELS_FETCH_SUCCESS';
export const AUTOCOMPLETE_SET_VALUES = 'filtering/AUTOCOMPLETE_SET_VALUES';
export const FILTER_DEFAULT_VALUE_FETCH_FAILURE =
  'filtering/FILTER_DEFAULT_VALUE_FETCH_FAILURE';
export const FILTER_DEFAULT_VALUE_FETCH_SUCCESS =
  'filtering/FILTER_DEFAULT_VALUE_FETCH_SUCCESS';
export const CHANGE_FILTER_NODE_PROPERTY =
  'filtering/CHANGE_FILTER_NODE_PROPERTY';
export const HIERARCHY_CHILDREN_FETCH = 'filtering/HIERARCHY_CHILDREN_FETCH';
export const HIERARCHY_CHILDREN_FETCH_FAILURE =
  'filtering/HIERARCHY_CHILDREN_FETCH_FAILURE';
export const HIERARCHY_CHILDREN_FETCH_SUCCESS =
  'filtering/HIERARCHY_CHILDREN_FETCH_SUCCESS';
export const LOCATION_PARSED = 'filtering/LOCATION_PARSED';
export const FOCUS_FILTER = 'filtering/FOCUS_FILTER';
export const REMOVE_FILTER = 'filtering/REMOVE_FILTER';
export const REMOVE_ALL_FILTERS = 'filtering/REMOVE_ALL_FILTERS';
export const RESET_RELOAD = 'filtering/RESET_RELOAD';
export const SCHEMA_RANGE_BOUNDS_FETCH_FAILURE =
  'filtering/SCHEMA_RANGE_BOUNDS_FETCH_FAILURE';
export const SCHEMA_RANGE_BOUNDS_FETCH_SUCCESS =
  'filtering/SCHEMA_RANGE_BOUNDS_FETCH_SUCCESS';
export const SET_FILTERS_CONFIG = 'filtering/SET_FILTERS_CONFIG';
export const TOGGLE_OPENED = 'filtering/TOGGLE_OPENED';
export const UPDATE_FILTER = 'filtering/UPDATE_FILTER';
export const USER_FILTERS_FETCH = 'filtering/USER_FILTERS_FETCH';
export const USER_FILTERS_FETCH_FAILURE =
  'filtering/USER_FILTERS_FETCH_FAILURE';
export const USER_FILTERS_FETCH_SUCCESS =
  'filtering/USER_FILTERS_FETCH_SUCCESS';
export const USER_FILTERS_REMOVE = 'filtering/USER_FILTERS_REMOVE';
export const USER_FILTERS_REMOVE_FAILURE =
  'filtering/USER_FILTERS_REMOVE_FAILURE';
export const USER_FILTERS_REMOVE_SUCCESS =
  'filtering/USER_FILTERS_REMOVE_SUCCESS';
export const USER_FILTERS_SET_DEFAULT = 'filtering/USER_FILTERS_SET_DEFAULT';
export const USER_FILTERS_SET_DEFAULT_FAILURE =
  'filtering/USER_FILTERS_SET_DEFAULT_FAILURE';
export const USER_FILTERS_SET_DEFAULT_SUCCESS =
  'filtering/USER_FILTERS_SET_DEFAULT_SUCCESS';
export const USER_FILTERS_SAVE = 'filtering/USER_FILTERS_SAVE';
export const USER_FILTERS_SAVE_FAILURE = 'filtering/USER_FILTERS_SAVE_FAILURE';
export const USER_FILTERS_SAVE_SUCCESS = 'filtering/USER_FILTERS_SAVE_SUCCESS';
